var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseChatbot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0004 11.1788L14.7146 15.8929C14.8718 16.0447 15.0823 16.1287 15.3008 16.1268C15.5193 16.1249 15.7283 16.0373 15.8828 15.8828C16.0373 15.7283 16.1249 15.5193 16.1268 15.3008C16.1287 15.0823 16.0447 14.8718 15.8929 14.7146L11.1788 10.0004L15.8929 5.28628C16.0447 5.12911 16.1287 4.91861 16.1268 4.70012C16.1249 4.48162 16.0373 4.27261 15.8828 4.1181C15.7283 3.96359 15.5193 3.87595 15.3008 3.87405C15.0823 3.87216 14.8718 3.95615 14.7146 4.10795L10.0004 8.82212L5.28626 4.10795C5.12838 3.9599 4.9191 3.87909 4.7027 3.8826C4.4863 3.88612 4.27975 3.97368 4.12676 4.12678C3.97378 4.27987 3.88636 4.48648 3.88299 4.70288C3.87963 4.91929 3.9606 5.12851 4.10876 5.28628L8.82209 10.0004L4.10792 14.7146C4.02833 14.7915 3.96485 14.8834 3.92117 14.9851C3.8775 15.0868 3.85451 15.1961 3.85355 15.3068C3.85259 15.4174 3.87367 15.5272 3.91557 15.6296C3.95747 15.732 4.01935 15.825 4.09759 15.9033C4.17584 15.9815 4.26888 16.0434 4.37129 16.0853C4.47371 16.1272 4.58344 16.1483 4.69409 16.1473C4.80474 16.1464 4.91409 16.1234 5.01576 16.0797C5.11743 16.036 5.20938 15.9725 5.28626 15.8929L10.0004 11.1788Z",
    fill: "#1E1E1E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseChatbot);
export default __webpack_public_path__ + "static/media/close-chatbot.b73a12c8ac4bbc3a57b15e54bdd372c4.svg";
export { ForwardRef as ReactComponent };